
export type NotificacaoEnum = number;
export let NotificacaoEnum: any = {};
NotificacaoEnum.danger = 0;
NotificacaoEnum.success = 1;
NotificacaoEnum.info = 2;
NotificacaoEnum.warning = 3;
NotificacaoEnum[NotificacaoEnum.danger] = "danger";
NotificacaoEnum[NotificacaoEnum.success] = "success";
NotificacaoEnum[NotificacaoEnum.info] = "info";
NotificacaoEnum[NotificacaoEnum.warning] = "warning";

